import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from "recharts";
import Card from "../ui/Card";
import { EmptyState } from "../ui/Table";
import { Users } from "lucide-react";
import { getNewVsChurnedSeries } from "../../lib/calculations";

export default function GrowthChart({ clients }) {
  const data = getNewVsChurnedSeries(clients, 12);
  const empty = data.every((d) => d.new === 0 && d.churned === 0);
  return (
    <Card title="New vs churned recurring clients (last 12 months)">
      {empty ? (
        <EmptyState icon={Users} title="No client activity yet" message="Add recurring clients to see growth over time." />
      ) : (
        <div style={{ width: "100%", height: 280 }}>
          <ResponsiveContainer>
            <BarChart data={data}>
              <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" vertical={false} />
              <XAxis dataKey="month" tick={{ fontSize: 11, fill: "#6d7a97" }} axisLine={false} tickLine={false} />
              <YAxis tick={{ fontSize: 11, fill: "#6d7a97" }} axisLine={false} tickLine={false} allowDecimals={false} />
              <Tooltip contentStyle={{ fontSize: 12, borderRadius: 8 }} />
              <Legend wrapperStyle={{ fontSize: 12 }} />
              <Bar dataKey="new" name="New" fill="#16a34a" radius={[4, 4, 0, 0]} />
              <Bar dataKey="churned" name="Churned" fill="#dc2626" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      )}
    </Card>
  );
}
